import { useState } from "react";
import api from "@/lib/api";

// "Join the club" email signup. Rendered above the footer on every page (App.js).
export default function EmailSignup() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle");

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setStatus("loading");
    try {
      await api.post("/newsletter/subscribe", { email: email.trim() });
      setStatus("done");
      setEmail("");
    } catch {
      setStatus("error");
    }
  };

  return (
    <section data-testid="email-signup-section" className="py-20 sm:py-28 px-6 border-t border-[#8A8A8A]/20 text-center">
      <h2 className="text-2xl sm:text-3xl font-medium uppercase tracking-[0.2em] text-[#F2F0EB]">Join The Club</h2>
      <p className="mt-4 text-xs sm:text-sm text-[#8A8A8A] tracking-[0.1em]">Early access to drops and restocks.</p>

      {status === "done" ? (
        <p data-testid="email-signup-success" className="mt-8 text-xs uppercase tracking-[0.2em] text-[#F2F0EB]">You're on the list.</p>
      ) : (
        <form onSubmit={submit} className="mt-8 flex flex-col sm:flex-row items-stretch justify-center gap-3 max-w-md mx-auto">
          <input
            data-testid="email-signup-input"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="EMAIL ADDRESS"
            className="flex-1 bg-transparent border border-[#8A8A8A]/40 text-[#F2F0EB] placeholder-[#8A8A8A] px-4 py-3 text-xs tracking-[0.15em] uppercase focus:border-[#F2F0EB] focus:outline-none"
          />
          <button
            data-testid="email-signup-submit"
            type="submit"
            disabled={status === "loading"}
            className="bg-[#F2F0EB] text-[#0A0A0A] font-['Oswald'] font-semibold text-xs tracking-[0.2em] uppercase px-8 py-3 hover:bg-[#8A8A8A] transition-colors disabled:opacity-50"
          >
            {status === "loading" ? "..." : "Join"}
          </button>
        </form>
      )}
      {status === "error" && (
        <p data-testid="email-signup-error" className="mt-4 text-[11px] uppercase tracking-[0.15em] text-[#8A8A8A]">Something went wrong. Please try again.</p>
      )}
    </section>
  );
}
